
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': '测试',
	'visualizationSlideoutTitle': '可视化',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': '请输入数字',
	'maxValuePlaceholder': '请输入数字',
	'customRangeErrorMessage': '值必须为数字',
	'propFillColor': '填充颜色',
	'propBorderColor': '边框颜色',
	'propBorderRadius': '角半径 (px)',
	'propColorPalette': '当前调色板',
	'propColorPaletteChangeLabel': '更改调色板',
	'propNewColorPaletteLabel': '创建自定义调色板',
	'propNewHeatPaletteLabel': '创建自定义热点调色板',
	'showTitleLabel': '显示标题',
	'titleTypeLabel': '标题类型',
	'smartTitleLabel': '智能标题',
	'customTitleLabel': '自定义标题',
	'noTitleLabel': '无标题',
	'colorPaletteTitle': '选用板',
	'responsiveTitleLabel': '响应标题',
	'propHeatScalePalette': '当前热点调色板',
	'propHeatPaletteChangeLabel': '更改热点调色板',
	'propMaintainAxisScales': '保持轴刻度',
	'propLineAndSymbolColor': '线条和符号颜色',
	'propLineAndSymbolPalette': '线条和符号调色板',
	'propElementColor': '元素颜色',
	'propColumnColor': '柱形颜色',
	'propColumnPalette': '柱形图调色板',
	'propColumnHeatPalette': '列热点调色板',
	'propBarColor': '条形颜色',
	'propGoalColor': '目标颜色',
	'propToColor': '目标色',
	'propFromColor': '原色',
	'propNumberValidationErrorMessageId': '请输入数字',
	'fontSizeAuto': '自动',
	'propAutoBinCount': '组数',
	'propAutoBinToggle': '自动分组',
	'tabName_general': '常规',
	'tabName_visDetails': '详细信息',
	'tabName_animation': '动画',
	'tabName_mediaDetails': '媒体详细信息',
	'tabName_webDetails': 'Web 页面详细信息',
	'tabName_imageDetails': '图像详细信息',
	'tabName_visualization': '可视化',
	'tabName_text': '文本',
	'sectionName_colorsAndThemes': '颜色和主题',
	'sectionName_appearance': '外观',
	'sectionName_general': '常规',
	'sectionName_colorPalette': '颜色',
	'sectionName_axis': '轴',
	'sectionName_axis_label': '轴',
	'sectionName_legend': '图注',
	'sectionName_chart': '图表',
	'sectionName_regionLayer': '区域层',
	'sectionName_pointLayer': '点层',
	'sectionName_latLongLayer': '纬度/经度层',
	'sectionName_pathLayer': '路径层',
	'sectionName_xAxis': 'X 轴',
	'sectionName_yAxis': 'Y 轴',
	'sectionName_xAxis_title': 'X 轴轴名',
	'sectionName_yAxis_title': 'Y 轴轴名',
	'sectionName_xAxis_label': 'X 轴轴标',
	'sectionName_yAxis_label': 'Y 轴轴标',
	'sectionName_column_yAxis': '柱形 Y 轴',
	'sectionName_column_yAxis_label': '柱形 Y 轴轴标',
	'sectionName_column_yAxis_title': '柱形 Y 轴轴名',
	'sectionName_line_yAxis': '折线 Y 轴',
	'sectionName_line_yAxis_label': '折线 Y 轴轴标',
	'sectionName_line_yAxis_title': '折线 Y 轴轴名',
	'sectionName_title': '标题',
	'sectionName_legendTitle': '图注标题',
	'sectionName_legendLabels': '图注标签',
	'sectionName_innerValueLabel': '内部值标签',
	'sectionName_style': '样式',
	'propTransparencyDescription': '使对象更透明或更不透明。请输入介于 0 和 100 之间的值',
	'smart_annotation_unauthorized': '注解：未经授权的访问',
	'smart_annotation_method': '注解：不允许使用方法',
	'smart_annotation_media': '注解：不允许使用媒体类型',
	'smart_annotation_input': '注解：输入无效',
	'smart_annotation_internal': '注解：内部系统错误',
	'smart_annotation_generic_error': '注解：服务错误',
	'smart_annotation_dialog_title': '洞察',
	'smart_annotation_Show_Insights': '显示洞察',
	'smart_annotation_Relationship': '关系为',
	'forecast_enter_number': '请输入数字，介于',
	'and': ' 和',
	'smart_errors': '注解错误：',
	'smart_warnings': '注解警告：',
	'smart_annotation_insight_icon_title': '洞察',
	'smart_annotations_toggle_on': '开启洞察',
	'smart_annotations_toggle_off': '关闭洞察',
	'smart_annotation_toggle_on': '切换开启',
	'smart_annotation_toggle_off': '切换关闭',
	'smart_annotation_insight_unavailable': '洞察当前不可用',
	'smart_annotation_insight_topBottom_percent_unsupported': '应用最高或最低 % 过滤器时，洞察不可用',
	'smart_annotation_forecast_topBottom_percent_unsupported': '应用最高或最低 % 过滤器时，预测不可用',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': '应用最高或最低过滤器，并且字段中有多列时，洞察不可用',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': '应用最高或最低过滤器，并且字段中有多列时，预测不可用',
	'forecast_title': '预测',
	'forecast_show': '显示预测',
	'forecast_toggle_on': '开启预测',
	'forecast_toggle_off': '关闭预测',
	'statDetails_title': '请参阅统计详细信息',
	'forecast_optional_factors_max_info': '最多可添加 %{max} 个因子',
	'forecast_optional_factors_num_added': '%{added}/%{max}',
	'forecast_optional_factors': '可选的考虑因素',
	'forecast_optional_factors_placeholderDropzone': '单击数据或将数据拖到此处',
	'forecast_item_tooltip': '来源：',
	'insightsNarrator': '描述性洞察',
	'statDetailsPerspectiveTitle': '分析',
	'emptyStatDetailsPanel': '没有其他分析可用于当前可视化。',
	'predict_errors': '分析错误',
	'predict_warnings': '分析警告',
	'fpd_invalid_data_source': '此数据源没有关联的智能模块',
	'fpd_network_issue': '针对此数据源执行分析时发生问题',
	'fpd_data_source_category': '缺少智能模块',
	'fpd_response_errors': '建议动因错误',
	'fpd_response_warnings': '建议动因警告',
	'catalyst_service_bad_request': '请求错误',
	'catalyst_service_unkown_Id': '找到未知请求标识',
	'catalyst_service_internal_server_error': '内部服务器错误',
	'catalyst_service_generic_error': 'Catalyst 服务错误',
	'catalyst_service_error': '此服务当前不可用',
	'propLegendPosition': '图注位置',
	'propLeft': '左侧',
	'propRight': '右侧',
	'propTop': '顶部',
	'propBottom': '底部',
	'propNone': '无',
	'propLegendDisplay': '显示图注',
	'targetThicknessPlaceHolder': '%{min} 到 %{max}',
	'targetThicknessErrorMsg': '请输入介于 %{min} 和 %{max} 之间的整数。',
	'possibleKeyDriver_DialogDriversLabelBegin': '动因（',
	'possibleKeyDriver_DialogDriversLabelEnd': '已选择）',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': '重置为默认值',
	'possibelKeyDriver_AddNewDrivers': '添加更多动因',
	'possibleKeyDrivers_NonRecommended_Placeholder': '搜索以添加更多动因',
	'possibleKeyDrivers_MaxPossibleReached': '取消选择一些动因以添加或选择其他动因',
	'possibleKeyDrivers_Recommended': '建议',
	'visRecommendedTypes': '建议的可视化类型',
	'visRecommender_smartsfailure': '可视化建议当前不可用',
	'visMore': '更多...',
	'visMoreTooltip': '更多可视化',
	'visOtherTypes': '其他可视化类型',
	'visChange': '更改可视化',
	'automaticTypeCaption': '自动',
	'propVisType': '可视化类型',
	'dlg_loading': '正在装入...',
	'snippetListChartCaption': '片段列表',
	'convoClusterChartCaption': '会话集群',
	'areaChartCaption': '面积图',
	'barChartCaption': '条形图',
	'columnChartCaption': '柱形图',
	'stackedbarChartCaption': '堆积条形图',
	'stackedcolumnChartCaption': '堆积柱形图',
	'bubbleChartCaption': '气泡图',
	'marimekkoChartCaption': 'Marimekko 图',
	'cometChartCaption': '动因分析',
	'scatterChartCaption': '散点图',
	'lineChartCaption': '直线',
	'pointChartCaption': '点状图',
	'heatChartCaption': '热图',
	'bulletChartCaption': '项目符号',
	'waterfallChartCaption': '瀑布图',
	'radarChartCaption': '雷达图',
	'boxplotChartCaption': '箱图',
	'pieChartCaption': '饼形图',
	'mapChartCaption': '地图',
	'radialBarChartCaption': '径向图',
	'compositeChartCaption': '柱形折线图',
	'wordCloudChartCaption': '字云',
	'networkChartCaption': '网络图',
	'relationshipNetworkChartCaption': '关系网络',
	'treemapChartCaption': '树状图',
	'packedBubbleChartCaption': '压缩气泡图',
	'hierarcicalPackedBubbleChartCaption': '层级气泡图',
	'spiralChartCaption': '螺旋图',
	'decisionTreeChartCaption': '决策树',
	'legacyMapChartCaption': '原有地图',
	'sunburstChartCaption': '旭日图',
	'visUsageComparison': '比较',
	'visUsageRelationships': '关系',
	'visUsageTrend': '趋势',
	'visUsagePartsToWhole': '部分对整体',
	'visUsageGeospatial': '地理空间',
	'visUsageAdvanced': '高级分析',
	'visUsageTablesAndSummary': '表和摘要',
	'visUsageSocialInsights': '社交洞察',
	'visUsageOther': '其他',
	'visualizationAnalytics': '分析',
	'autoBinActionText': '自动分组',
	'filterAutobinActionText': '过滤分箱',
	'memberCalculationActionText': '成员计算',
	'toolbarActionCalculation': '创建计算',
	'toolbarActionEditCalculation': '编辑计算',
	'topBottomRankLabel': '排名 (%{label})',
	'toolbarDeleteFilterActionText': '除去过滤器',
	'toolbarActionTopKeyDrivers': '显示动因',
	'toolbarActionCustomGroup': '自定义组',
	'canNotCreateCustomGroup': '无法创建此自定义组。',
	'aria_label_datatable': '数据表',
	'summaryCaption': '汇总',
	'MeasuresCaption': '度量',
	'MeasuresGroupCaption': '度量组（%{count} 个）',
	'ValuesCaption': '值',
	'turnInsightsOn': '开启洞察',
	'turnInsightsOff': '关闭洞察',
	'decisionRules': '规则',
	'decisionTree': '树形图',
	'decisionSunburst': '树形旭日图',
	'switchToDecisionRules': '切换至决策规则',
	'switchToDecisionTree': '切换至决策树',
	'data_group_less_then': '小于 %{rangeTo}',
	'data_group_to': '%{rangeFrom} 到 < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} 及以上',
	'nullValueContent': '（无值）',
	'sum': '总和',
	'count': '计数',
	'countdistinct': '计数差异',
	'avg': '平均值',
	'min': '最小值',
	'max': '最大值',
	'automatic': '自定义',
	'variance': '偏差',
	'stddev': '标准偏差',
	'median': '中间值',
	'calculated': '已计算',
	'none': '无',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': '提示值',
	'inputLabelPrompt': '值',
	'inputPlaceholderPrompt': '输入值',
	'inputInvalidText': '针对 %{dataType} 类型的输入无效',
	'unSupportedPrompt': '不受支持的提示',
	'missingDataSource': '找不到正确的数据源。',
	'unSupportedPromptType': '当前不支持提示方案。',
	'preAggregateLabel': '应用数据源中的提示值',
	'postAggregateLabel': '在报表中应用提示值',
	'preAggregateText': '该范围使用数据源中的值，而不是仪表板中显示的值。',
	'defaultAggregation_count': '计数',
	'defaultAggregation_countdistinct': '计数差异',
	'defaultAggregation_max': '最大值',
	'defaultAggregation_min': '最小值',
	'defaultAggregation_avg': '平均值',
	'defaultAggregation_sum': '总和',
	'defaultAggregation_auto': '自动 (%{aggregationType})',
	'keydriver_average': '整体平均值',
	'keydriver_up_down': '突出显示的组具有高平均值或低平均值，对目标具有较大影响。通常具有高平均值或低平均值的组具有最强影响。',
	'keydriver_different': '突出显示的组的分布与整体分布完全不同。这些组对目标的影响更大。',
	'topOperator': '顶部',
	'bottomOperator': '底部',
	'topBottomFact': '%{operator} %{value}%{percent}（按 %{columnLabel}）',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': '删除最高或最低计数',
	'deleteTopBottomPercent': '删除最高或最低百分比',
	'topBottomTitle': '仅限此对象',
	'deleteTopBottom': '删除最高或最低计数',
	'editTopBottom': '编辑最高或最低计数',
	'editTopBottomCount': '编辑最高或最低计数',
	'editTopBottomPercent': '编辑最高或最低百分比',
	'deleteDrillOperation': '取消钻取操作',
	'ariaDeleteTopBottomCountLabel': '按 DELETE 键以删除最高或最低计数。',
	'ariaDeleteTopBottomPercentLabel': '按 DELETE 键以删除最高或最低百分比。',
	'ariaEditTopBottomCountLabel': '按 ENTER 键以编辑最高或最低计数。',
	'ariaEditTopBottomPercentLabel': '按 ENTER 键以编辑最高或最低百分比。',
	'ariaDeleteDrillStateLabel': '按 Enter 键以编辑钻取操作。',
	'drillUpStateTitle': '向上钻取',
	'drillDownStateTitle': '向下钻取',
	'ariaEditTopBottomLabel': '按 ENTER 键以编辑最高或最低计数。',
	'ariaDeleteTopBottomLabel': '按 DELETE 键以删除最高或最低计数。',
	'allKeyDriversLabel': '自动（所有动因）',
	'filter_drag_and_drop_single_dock': '将数据拖放到此处以进行过滤。',
	'filter_drag_and_drop_all_tabs': '将数据拖放到此处以过滤所有选项卡。',
	'filter_drag_and_drop_current_tab': '将数据拖放到此处以过滤此选项卡。',
	'filter_empty_consume_mode': '未应用任何过滤器。',
	'filterClearAllItems': '清除所有过滤器',
	'filterDeleteAllItems': '删除所有过滤器',
	'filterDockChevronLeft': '滚动浏览数据',
	'filterDockChevronRight': '滚动浏览数据',
	'filterIconLabel_Single': '过滤器',
	'filterIconLabel_Global': '所有选项卡',
	'filterIconLabel_Tab': '此选项卡',
	'filterIconTooltip_Single': '过滤器',
	'filterIconTooltip_Global': '所有选项卡的过滤器',
	'filterIconTooltip_Tab': '此选项卡的过滤器',
	'filterDropZoneTooltip_Single': '过滤器放下区域',
	'filterDropZoneTooltip_Global': '所有选项卡的过滤器放下区域',
	'filterDropZoneTooltip_Tab': '此选项卡的过滤器放下区域',
	'filterOverflowMenu': '更多',
	'expand': '展开',
	'collapse': '折叠',
	'filterDockItemNameAriaLabel': '按 Enter 键以启动过滤器对话框并定义过滤器。',
	'filterItemCanvasMove': '添加到画布',
	'addToCascadeSet': '添加到级联集',
	'removeFromCascadeSet': '从级联集除去',
	'filterItemDelete': '删除过滤器',
	'filterInvertRange': '除以下项外的所有项：%{from} 到 %{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': '不在 %{from} 之后',
	'filter_date_after': '%{from} 之后',
	'filter_date_before_except': '不在 %{to} 之前',
	'filter_date_before': '%{to} 之前',
	'filter_date_between_except': '不介于 %{from} 和 %{to} 之间',
	'filter_date_between': '介于 %{from} 和 %{to} 之间',
	'filterValueSeparator': ',',
	'filterAll': '全部',
	'filter': '过滤器',
	'filterExcept': '除 %{values} 外',
	'filterDockToolbarButtonLabel': '过滤器坞',
	'navigateTitle': '导航至',
	'navigateSelectColumn': '选择列',
	'navigateSelectPath': '选择导航路径',
	'current_nav_group': '当前导航组为 %{navigation_group_name}',
	'next': '下一步',
	'previous': '上一页',
	'multiselectMsg': '已选择 %{count} 项',
	'errMsgFilterItemMissingTitle': '无法装入过滤器值 %{itemName}，因为这些值不可用于此数据集',
	'errMsgFilterItemGenericTitle': '无法装入过滤器值',
	'textFilterItemsNotFound': '没有可用项。',
	'nullValueLabel': '（空白）',
	'filterConditionLabel': '过滤条件',
	'filter_includesAll': '全部包含',
	'filter_allMembersOfSet': '集的所有成员',
	'modelFilter': '过滤器',
	'filtersTitle': '过滤属性',
	'search': '搜索',
	'clearTextFilterValue': '清除',
	'invertFilterSelection': '反转',
	'modellingLoading': '正在装入...',
	'searchAll': '查找所有列',
	'toolbarActionPossibleKeyDrivers': '编辑作用域',
	'toolbarActionPossibleKeyDriversSubTitle': '考虑将项从左侧拖至动因分析图表中',
	'toolbarActionSort': '排序',
	'toolbarActionSortAscending': '升序',
	'toolbarActionSortDescending': '降序',
	'toolbarActionSortAuto': '自动 (%{sortOrder})',
	'toolbarActionSortCustom': '自定义',
	'toolbarActionFormat': '格式化数据',
	'toolbarActionFormatText': '格式化数据（文本）',
	'toolbarActionFormatAbbreviation': '缩写',
	'toolbarActionFormatNone': '自动',
	'toolbarActionFilter': '过滤器',
	'toolbarActionTopBottom': '顶部或底部',
	'toolbarActionRmvShape': '除去形状',
	'toolbarActionToggleShapeDrop': '信息图形状',
	'toolbarActionToggleShapeDropTitle': '创建信息图',
	'toolbarActionToggleShapeDropText': '将形状拖至此字段以创建信息图。',
	'toolbarActionAggregationType': '汇总',
	'toolbarDeleteActionText': '除去列',
	'toolbarTextActionText': '样式文本',
	'toolbarActionFilterLocalKeepSelected': '保留',
	'toolbarActionFilterLocalExcludeSelected': '排除',
	'toolbarActionFilterAllKeepSelected': '过滤器',
	'toolbarActionSimpleCalculation': '简单计算',
	'toolbarActionDrillBack': '返回',
	'toolbarActionDrillUp': '向上钻取',
	'toolbarActionDrillDown': '向下钻取',
	'toolbarActionJumpTo': '穿透钻取',
	'toolbarActionNavigate': '导航',
	'toolbarActionCreateFilterGroup': '新建连接',
	'toolbarActionDisconnectFilterGroup': '中断所有链接',
	'toolbarActionLinkFilterGroup': '添加到现有连接',
	'toolbarActionLassoSelect': '选择工具',
	'toolbarActionRefreshDeveloperWidget': '刷新',
	'textFontFamilySubClassHairline': '细线',
	'textFontFamilySubClassThin': '细',
	'textFontFamilySubClassThinItalic': '细斜体',
	'textFontFamilySubClassExtraLight': '超细体',
	'textFontFamilySubClassExtraLightItalic': '超细斜体',
	'textFontFamilySubClassLight': '标准细体',
	'textFontFamilySubClassLightItalic': '细斜体',
	'textFontFamilySubClassRegular': '普通',
	'textFontFamilySubClassRegularItalic': '普通斜体',
	'textFontFamilySubClassItalic': '斜体',
	'textFontFamilySubClassMedium': '中',
	'textFontFamilySubClassMediumItalic': '中斜体',
	'textFontFamilySubClassHeavy': '重',
	'textFontFamilySubClassHeavyItalic': '重斜体',
	'textFontFamilySubClassDemiBold': '半粗体',
	'textFontFamilySubClassDemiBoldItalic': '半粗斜体',
	'textFontFamilySubClassBold': '粗体',
	'textFontFamilySubClassBoldItalic': '粗斜体',
	'textFontFamilySubClassExtraBold': '超粗体',
	'textFontFamilySubClassExtraBoldItalic': '超粗斜体',
	'textFontFamilySubClassBlack': '黑色',
	'textFontFamilySubClassBlackItalic': '黑斜体',
	'textFontFamilySubClassStencil': '镂刻体',
	'dlg_ascending': '升序',
	'dlg_descending': '降序',
	'dlg_custom': '自定义',
	'dlg_none': '无',
	'dlg_hierarchy': '层级',
	'dlg_namedSet': '命名集',
	'dlg_rank': '排名',
	'visualizationLabel': '可视化',
	'chartLabel': '%{chartName} 图表',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': '按 F12 以在窗口小部件中浏览。',
	'f10KeyDescription': '按 F10 键以启动窗口小部件焦点视图',
	'playButtonLabel': '播放',
	'dataPlayerValueListLabel': '数据播放器值',
	'localFilterTitle': '仅限此对象',
	'globalFilterTitle': '所有对象',
	'deleteFilter': '删除过滤器',
	'editFilter': '编辑过滤器',
	'ariaEditFilterLabel': '按 ENTER 键以编辑过滤器。',
	'ariaDeleteFilterLabel': '按 DELETE 键以删除过滤器。',
	'measureFilterBetween': '介于 %{lowerBound} 和 %{upperBound} 之间',
	'measureFilterNotBetween': '不介于 %{lowerBound} 和 %{upperBound} 之间',
	'dimFilterIn': '包含：%{in}',
	'dimFilterNotIn': '排除：%{out}',
	'gtFilter': '大于 %{lowerBound}',
	'afterFilter': '%{lowerBound} 之后',
	'beforeFilter': '%{upperBound} 之前',
	'gteFilter': '大于或等于 %{lowerBound}',
	'ltFilter': '小于 %{upperBound}',
	'lteFilter': '小于或等于 %{upperBound}',
	'ariaEditPrompt': '按 ENTER 键以更改提示值',
	'dataPointFilterTitle': '数据点',
	'dataPointFilterIncludeSummary': '已包含 %{valueCount} 个数据点',
	'dataPointFilterExcludeSummary': '已排除 %{valueCount} 个数据点',
	'widgetFiltersLabel': '窗口小部件过滤器',
	'coachMarkTitleSpiralTarget': '编辑作用域',
	'coachMarkContentSpiralTarget': '您可以在此访问和修改目标的动因选择。',
	'srILVTreeLabel': '列表',
	'geomapUnrecognizedLocations': '无法识别的位置：',
	'geomapAmbiguousLocations': '不明确的区域：',
	'visualizationNotifications': '可视化通知：',
	'dataNotifications': '数据通知：',
	'autobinSuggestion': '开启自动分组',
	'LIVE_empty_visualization_hint_title': '构建可视化',
	'LIVE_empty_visualization_hint_description': '将数据拖到此处或拖到字段上。',
	'LIVE_slots_required_field_description': '%{asterisk} 指示必填字段',
	'LIVE_slots_drag_and_drop_description': '将数据拖放到字段上方以构建并过滤可视化。',
	'tooltipSlotDefaultCaption': '工具提示',
	'tooltipSlotCompositeLineCaption': '行工具提示',
	'tooltipSlotCompositeColumnCaption': '列工具提示',
	'dwErrorLoadingAvailableVisualizations': '无法装入可用可视化定义',
	'moreDataIndicator': '数据已在 %{threshold} 项处被剪切。应用过滤器以显示更少内容。',
	'nonCtxTopBottomInvalid': '交叉表不支持在没有上下文的情况下定义最高或最低规则。已从此交叉表视图中将其除去。重新定义 %{columnName} 的上下文中一个或多个类别的规则。',
	'dwErrorLoadingVisualizationNotFound': '无法装入对象，因为此对象缺少可视化定义。',
	'dwErrorLoadingVisualizationListNotFound': '无法装入可视化。',
	'dwErrorRunningQuery': '无法在数据集 %{datasetName} 中检索数据。',
	'dwErrorGeoData': '在地图中显示地理数据时遇到问题。请选择其他可视化类型。',
	'dwPromptSignonCancelWarning': '此可视化的数据不可用。请提供正确凭证。',
	'dwErrorMissingDataset': '无法装入可视化，因为其关联的数据集“%{datasetName}”不可用。',
	'dwErrorRenderingVisualization': '无法装入此可视化。',
	'dwErrorVisualizationTooSmall': '可视化过小，无法显示其所包含的数据。请放大可视化或限制其包含的数据。',
	'errorSourceNotFound': '无法装入可视化，因为其关联的源“%{sourceName}”不可用。',
	'errorActionNotSupported': '数据源“%{sourceName}”不支持此操作。',
	'errorMeasureNotSupportedOnMultiEdges': '可视化在多个边缘上具有度量，但不再支持此情况。请将度量仅放在一个边缘上。',
	'errorExceedAllowableValue': '估算的单元格数已超过允许值 100000。对已规划的集合应用过滤以减少单元格数。',
	'propScaleLabel': '图标的数量',
	'propScaleDescription': '选择图标的数量',
	'propScaleFew': '低',
	'propScaleDefault': '默认',
	'propScaleMany': '高',
	'lastRefresh': '上次刷新时间：%{timeInterval} 之前',
	'widgetTimer': '窗口小部件计时器',
	'datasetItemsUnavailable': '此可视化中使用的某些数据集项不可用。',
	'datasetItemUnavailable': '此数据集项不可用',
	'retry': '重试',
	'widgetConditionalFormatLabel': '切换条件格式控件',
	'widgetConditionalFormatTitle': '编辑条件格式化颜色',
	'crosstabName': '交叉表',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': '不适用',
	'summaryLabel': '值为 %{value} 的 %{label}',
	'infographicLabel': '值为 %{value} 的 %{label}',
	'warning': '警告',
	'swapRowsAndColumns': '交换行和列',
	'hideSummariesLabel': '隐藏摘要',
	'showSummariesLabel': '显示摘要',
	'hideRowColumn': '隐藏',
	'showAllRowColumn': '全部显示',
	'dataAssetPropertiesLabel': '可视化属性',
	'evAdd': '添加列',
	'evCollapse': '折叠',
	'evColumns': '列数',
	'evLocalFilters': '本地过滤器',
	'evExpand': '展开',
	'evFilterTooltip': '过滤器',
	'missingColumn': '缺少：%{columnLabel}',
	'missingFiltering': '列上缺少过滤器：',
	'missingDataItem': '在窗口小部件中找不到引用的数据项“%{dataItemId}”。',
	'heatByLabel': '热度依据',
	'toolbarChangeVisualization': '更改可视化',
	'modellingRelatedTablesNoneFound': '找不到相关表',
	'tablesNotJoined': '未定义表之间的关系。',
	'fixTableJoin_edit': '查看关系',
	'processing': '正在处理...',
	'errorCellWarning': '无法计算某些摘要值。',
	'aggregateTypeToggler': '显示聚合类型',
	'maxColumnsExceeded': '超出了最大列数。%{columns} 已删除。',
	'unboundColumns': '无法使用以下列：%{columns}。',
	'unboundColumn': '无法使用以下列：%{columns}。',
	'recommendRequestFailed': '建议请求失败。请与管理员联系。',
	'visualizationDoesNotSupportOLAP': '无法创建基于 OLAP 数据源的此可视化。请使用其他支持的数据源。',
	'showDataBehindVizLabel': '显示数据',
	'showDataBehindVizNotSupportedLabel': '此可视化类型不支持显示数据',
	'exploreData': '探索...',
	'newExplore': '新建探索',
	'thumbnails_error_fetching': '访存缩略图时出错',
	'loadedThumbnailImage': '已装入 %{visType} 可视化缩略图',
	'autobinAxisLabel': '组',
	'recommended_visualizations': '建议的可视化',
	'all_visualizations': '所有可视化',
	'edit': '编辑',
	'selectTargetDialogTitle': '选择穿透钻取目标',
	'noTargetInCM': '找不到穿透钻取的目标',
	'errorDrillDefinition': '在添加或编辑穿透钻取定义时发生错误。',
	'errorDrillToTarget': '钻取到“%{targetName}”时发生错误',
	'drillThroughMappingViewLabel': '将仪表板中的列分配给目标报表的提示',
	'drillthroughScopeRadioLabel': '将此定义应用于：',
	'drillthroughScopeRadioOptionVisualization': '仅限此可视化',
	'drillthroughScopeRadioOptionConnection': '同一连接中使用相同数据源的可视化',
	'drillthroughScopeRadioOptionDashboard': '%{perspective} 上使用相同数据源的任何可视化',
	'drillThroughParametersColumnTitle': '“%{targetName}”提示：',
	'drillThroughMetadataColumnTitle': '“%{boardName}”数据列：',
	'drillThroughDefinitionNoParameter': '穿透钻取目标没有提示。',
	'drillThroughDefinitionErrorQueryingReport': '更正目标报表的问题，然后重试创建穿透钻取定义。',
	'drillThroughDefinitionErrorDlgTitle': '出错了！',
	'dlg_back': '返回',
	'dlg_close': '关闭',
	'dlg_ok': '确定',
	'dlg_cancel': '取消',
	'dlg_apply': '应用',
	'dlg_create': '创建',
	'dlg_done': '完成',
	'drillthrough_unsaveMsg': '要继续而不保存“%{name}”吗？',
	'drillthrough_jumpTo': '穿透钻取定义：%{name}',
	'drillthrough_jumpToLabel': '穿透钻取',
	'drillthrough_manage': '管理...',
	'drillthrough_addNewTarget': '添加新的穿透钻取定义',
	'drillthrough_manageJumpPaths': '管理穿透钻取定义',
	'drillthrough_manageJumpPaths_edit': '编辑“%{name}”',
	'drillthrough_manageJumpPaths_delete': '删除“%{name}”',
	'drillthrough_manageAddAnotherTarget': '添加其他穿透钻取定义',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': '确认删除',
	'drillthrough_manageConfirmeDeleteDrillTarget': '确定要删除穿透钻取“%{name}”吗？',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': '穿透钻取名称重复',
	'drillthrough_definitionMessage': '已存在穿透钻取“%{name}”。请提供其他名称',
	'drillthrough_jumpToTarget_notFound': '找不到穿透钻取“%{name}”的目标',
	'drillThroughDefinitionNoParameterSubTitle': '不会将任何上下文传递给目标报表。',
	'drillthrough_titleLabel': '名称',
	'drillthrough_create_dialogTitle': '创建穿透钻取定义',
	'drillthrough_edit_dialogTitle': '编辑穿透钻取定义',
	'drillthrough_subTitle': '源中可视化的上下文用于过滤目标 %{perspective}。',
	'drillthrough_selectColumn': '选择列',
	'noPrompt': '无提示',
	'promptDialog': '%{promptType} 提示对话框',
	'formatAutoDescription': '“自动”指定从数据源或可视化继承的格式。',
	'formatDefaultDescription': '“默认值”指定从系统继承的格式',
	'createCustomGroupAction': '创建数据组',
	'removeCustomGroupAction': '移除数据组',
	'editCustomGroupAction': '编辑数据组',
	'renameCustomGroupAction': '重命名数据组',
	'createCustomGroupErrorToast': '无法创建数据组。',
	'removeCustomGroupErrorToast': '无法移除数据组。',
	'editCustomGroupErrorToast': '无法编辑数据组。',
	'renameCustomGroupErrorToast': '无法重命名数据组。',
	'customGroupLabel': '创建数据组',
	'ungroupCustomGroupLabel': '取消分组',
	'renameCustomGroupLabel': '重命名',
	'createCustomGroupLabel': '创建',
	'customGroupingLabel': '%{columnLabel}（组）',
	'createCustomBinningErrorToast': '无法创建自动组。',
	'removeCustomBinningErrorToast': '无法除去自动组。',
	'createCustomSort': '创建自定义排序',
	'unavaiableData': '没有数据',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': '选择可用项，然后对其重新排序以创建自定义排序。',
	'availableItems': '可用项',
	'selectAll': '全选',
	'customSortOrder': '自定义排序顺序',
	'selectAvailableItemsDesc': '选择可用项，然后在此对其重新排序。',
	'moveToTop': '移至顶部',
	'clear': '清除',
	'sortRemainingItemsBy': '其余项的排序依据',
	'removeAll': '全部移除',
	'resetTooltip': '将从 %{customSortOrder} 列表除去所有项。此外，%{sortRemainingItemsBy} 下拉列表将还原为默认值。',
	'manyItemsWarning': '选择多个项可能会影响仪表板的性能。',
	'manyItemsSelected': '已选择超过 %{maxItems} 项，这可能会影响仪表板的性能。',
	'somethingWentWrong': '糟糕，出错了。',
	'tryAgain': '重试',
	'customSortLabel': '自定义排序',
	'applyError': '无法应用 %{action}。',
	'searchReturnedNoResults': '您的搜索未返回任何结果。',
	'extVisSystem': '系统',
	'extVisCustom': '自定义',
	'customVisTestVisualization': '测试可视化',
	'extVisCustomVisPreview': '预览',
	'extVisCustomPreviewWidgets': '开发人员窗口小部件',
	'extVisCustomVVisualization': '可视化',
	'extVisCustomVisuals': '自定义可视项',
	'noPermissionToManage': '您无权管理自定义可视化。',
	'extVisCustomUpdate': '更新',
	'extVisCustomDelete': '删除',
	'extVisNoCustomVisuals': '无自定义可视项',
	'extVisNoCustomVisualsMsg': '组织中当前没有任何自定义可视项',
	'extVisAddCustomVisual': '添加自定义可视项',
	'extVisNoCustomVisualsAdminMsg': '当前没有任何自定义可视项。请首先添加自定义可视项',
	'extVisNoSDKConnection': '尚未创建与本地文件的连接',
	'extVisNoSDKPreviewMsg': '要预览可视化，请建立连接。',
	'extVisMore': '更多',
	'extVisDeleteDialogTitle': '删除自定义可视项',
	'extVisDeleteDialogBody': '确定要删除此自定义可视化吗？可能其他仪表板和报表正在使用此自定义可视化。',
	'extVisDeleteConfirmation': '自定义可视项已删除。',
	'extVisDeleteError': '无法删除自定义可视项。%{msg}',
	'extVisCloseToast': '立即关闭',
	'extVisAdd': '自定义可视项已成功添加。',
	'extVisAddError': '无法添加自定义可视项。%{msg}',
	'extVisUpdate': '自定义可视项已成功更新。',
	'extVisUpdateError': '无法更新自定义可视项。%{msg}',
	'extVisAddProgress': '正在导入 %{name}',
	'extVisUpdateProgress': '正在更新 %{name}',
	'extPermissionTitle': '访问受限制或已删除自定义可视项',
	'extPermissionBody': '无法查看此自定义可视项，因为此项已删除或其访问权受到限制。',
	'customVizSaveWarning': '无法保存自定义可视项。尚未导入自定义可视项。',
	'schematicTestCaption': '测试示意图',
	'schematicServiceRequestError': '示意图服务错误',
	'extVisPreviewMessage': '这是预览。尚未将可视化添加到该产品。',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': '未定义',
	'kpiDefaultTargetLabel': '目标',
	'kpiNonNumericTarget': '目标值必须为数字。',
	'kpiManualTargetSlotFilled': '值已在字段中应用',
	'kpiAutoValueSize': '自动',
	'kpiUnableDrawSparklineLabel': '无法绘制迷你图',
	'kpiUnableDrawSparklineInfo': '迷你图至少需要两个时间点。更改数据或调整过滤器以查看迷你图。',
	'conditionalFormattingTextColor': '文本颜色',
	'suppression': '抑制',
	'suppressNone': '无',
	'suppressRowsAndColumns': '行数和列数',
	'suppressRows': '行数',
	'suppressColumns': '列数',
	'enableSuppression': '启用消零',
	'disableSuppression': '禁用消零',
	'loadVisDefinitionError': '无法装入可视化 %{id} 的定义',
	'emptyVisualization': '空可视化',
	'expandCollapse': '展开和折叠',
	'expandBtnLabel': '展开',
	'collapseBtnLabel': '折叠',
	'prop_sizeInputNonNumericValue': '此值必须为数字。',
	'prop_sizeValueShouldBeHigher': '该值必须大于 %{value}。',
	'fontPropLabel': '字体系列',
	'fontSizePropLabel': '字体大小',
	'sectionItemAxisTitle': '项轴名',
	'sectionItemAxisLabel': '项轴标',
	'sectionValueAxisTitle': '值轴名',
	'sectionValueAxisLabel': '值轴标',
	'sectionRepeatColumnTitle': '重复列标题',
	'sectionRepeatRowTitle': '重复行标题',
	'styletext-widget.legend': '图注',
	'styletext-itemAxis.ticks.labels': '轴标',
	'styletext-valueAxis.title': '轴名',
	'styletext-itemAxis.title': '轴名',
	'styletext-labels': '数据标签',
	'styletext-valueAxis.line.title': '折线标题',
	'styletext-cellValue': '值',
	'styletext-values': '值',
	'styletext-rowHeading': '行标题',
	'styletext-columnHeading': '列标题',
	'regularFontStyle':'常规',
	'fontFamily': '系列',
	'fontSize': '大小',
	'visExportFileName': '可视化',
	'ds-missingDataSet': '找不到数据集。请确保已成功创建数据集。',
	'ds-missingDashboardId': '创建数据集前，请保存仪表板。',
	'ds-unsupportedDataSourceType': '不支持 %{type} 数据源类型。',
	'dataCache': '数据高速缓存',
	'dataCache_on': '启用',
	'dataCache_off': '无高速缓存',
	'dataCache_auto': '自动',
	'queryOptimization': '查询优化',
	'propshowDataGridInConsumeMode': '在预览中显示数据网格',
	'dtMatchMetadata': '使用匹配的元数据来过滤目标仪表板。',
	'dtMatchMetadata_info': '如果目标仪表板基于不同的数据源，那么在元数据标识匹配时应用过滤器。 这可能会影响性能。',
	'dtOverrideExistingFilters': '仅覆盖目标仪表板中已存在的全局过滤器。\n忽略源可视化上的其他过滤器。',
	'OnLoadFilterModifierDatasourceMismatch': '过滤器不会应用于目标，因为仪表板使用的是不同的源。',
	'OnLoadFilterModifierColumnMismatch': '未应用一个或多个过滤器，因为找不到匹配的列。',
	'showValuesOn': '显示值',
	'showValuesAsRowLabel': '行（最佳时）',
	'showValuesAsColumnLabel': '列（最佳时）',
	'dropdownMultiSelectClearAll': '清除所有选择',
	'dropdownSingleSelectClearAll': '清除选择',
	'dropdownOpenMenu': '打开菜单',
	'dropdownCloseMenu': '关闭  菜单',
	'cascadingFiltersSection': '级联过滤器设置',
	'cascadeStrategy': '级联集策略',
	'cascadeStrategy_FirstToLast': '第一个到最后一个',
	'cascadeStrategy_MultiDirectional': '多向',
	'cascade_globalToTab': '级联所有选项卡过滤器',
	'cascade_tabToLocal': '将此选项卡过滤器级联到本地',
	'showAllData': '显示所有值',
	'showAllFilterValue': '(%{value})',
	'valuesCascaded': '按所有选项卡过滤的值',
	'AnalyticsMsgDefault': '所选窗口小部件不使用预测或分析洞察',
	'AnalyticsDescriptionDefault': '选择支持分析的可视化，以查看和管理分析设置。',
	'AnalyticsMsgNoContent': '未选择任何可视化',
	'AnalyticsMsgMultiSelected': '已选择多个窗口小部件',
	'AnalyticsDescriptionMultiSelected': '选择一个可视化视图，以查看和管理其分析设置。',
	'ChartInsightPinnedSectionDescription':'共享仪表板时，还会共享您收藏的描述性洞察。 洞察可能会受到数据更改的影响，如果不适用于当前数据，就不会显示。',
	'ChartInsightNonPinnedSectionDescription':'建议的洞察是系统为可视化效果而生成的。 如果数据发生变化，这些洞察也可能会发生变化。',
	'ChartInsightPinnedSectionTitle':'收藏的洞察 (%{count})',
	'ChartInsightNonPinnedSectionTitle':'建议的洞察 (%{count})',
	'ChartInsightPinnedEmpty':'针对某个建议洞察单击星形图标，以将其添加到收藏夹。',
	'ChartInsightAllInsightsPinned': '没有新的洞察可用，或者所有建议的洞察都已添加到收藏夹。',
	'ChartInsightNoRecommendedInsights': '此可视化没有相关洞察。',
	'ChartInsightLoadingMessage':'查找数据的描述性洞察',
	'ChartInsightConsumePinnedInsightsDesc': '仪表板作者已收藏这些洞察。',
	'MoveUp':'向上移动洞察',
	'MoveDown':'向下移动洞察',
	'Star':'向收藏夹添加洞察',
	'Unstar':'从收藏夹中除去洞察',
	'DisabledUnstar': '收藏的洞察',
	'PdfPrintSectionLabel': 'PDF 打印设置',
	'PdfPrintOptionsLabel': '打印选项',
	'PdfPrintInViewLabel': '在视图中',
	'PdfPrintExtendedContentLabel': '扩展内容',
	'PdfPrintNewPageLabel': '新建页面'
});
